<div [hidden]="isInDetail">
    <list-view *ngIf="listeRoles" [liste]="listeRoles"></list-view>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>

<!-- Routeur pour afficher les pages enfants (le détail du rôle) -->
<router-outlet></router-outlet>